import { render, staticRenderFns } from "./WechatAuthroize.vue?vue&type=template&id=c3972a02&scoped=true&"
import script from "./WechatAuthroize.vue?vue&type=script&lang=js&"
export * from "./WechatAuthroize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3972a02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3972a02')) {
      api.createRecord('c3972a02', component.options)
    } else {
      api.reload('c3972a02', component.options)
    }
    module.hot.accept("./WechatAuthroize.vue?vue&type=template&id=c3972a02&scoped=true&", function () {
      api.rerender('c3972a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/WechatAuthroize.vue"
export default component.exports